import { ShieldCheck, Zap, Headset, Layers, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { scrollToSection, HUB_ORB_IMG } from "@/utils/scroll";

const POINTS = [
  { icon: ShieldCheck, title: "Reliable & secure", desc: "A dependable service with secure ordering and privacy respected at every step." },
  { icon: Zap, title: "Fast & smooth", desc: "Quick activation and streaming that keeps up with you — no fuss, no friction." },
  { icon: Headset, title: "Real support, 24/7", desc: "A friendly team on WhatsApp and email whenever you need a hand." },
  { icon: Layers, title: "Everything in one place", desc: "Plans, setup, streaming and support — one hub for your whole experience." },
];

export default function WhyHub() {
  return (
    <section id="why" className="relative overflow-hidden py-16 md:py-28" data-testid="why-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-14 lg:grid-cols-2">
          <Reveal className="relative order-2 lg:order-1">
            <div className="absolute -inset-8 rounded-full bg-[radial-gradient(ellipse_at_center,rgba(0,112,243,0.12),transparent_65%)] blur-3xl" aria-hidden="true" />
            <img
              src={HUB_ORB_IMG}
              alt="The IPTV HUB — glowing hub connecting your devices"
              loading="lazy"
              data-testid="why-hub-visual"
              className="relative mx-auto w-full max-w-lg rounded-3xl border border-slate-900/10 shadow-[0_0_70px_rgba(0,240,255,0.18)]"
            />
          </Reveal>

          <div className="order-1 lg:order-2">
            <Reveal>
              <p className="mb-3 text-xs font-bold uppercase tracking-[0.25em] text-electric">Why IPTV HUB</p>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
                Everything you need for a smooth and convenient entertainment experience — in one place.
              </h2>
            </Reveal>
            <div className="mt-10 space-y-6">
              {POINTS.map((p, i) => (
                <Reveal key={p.title} delay={0.14 + i * 0.08}>
                  <div className="flex gap-4" data-testid={`why-point-${i + 1}`}>
                    <div className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-electric/25 bg-electric/10 text-electric">
                      <p.icon className="h-5 w-5" />
                    </div>
                    <div>
                      <h3 className="font-display text-base font-semibold text-slate-900">{p.title}</h3>
                      <p className="mt-1 text-sm leading-relaxed text-slate-500">{p.desc}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
            <Reveal delay={0.5}>
              <button
                data-testid="why-view-plans-button"
                onClick={() => scrollToSection("#plans")}
                className="btn-ghost mt-10 inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-sm"
              >
                Explore plans <ArrowRight className="h-4 w-4" />
              </button>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
